module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.0ff8030d.svg";